/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-21 12:23:11
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-21 15:12:01
 * @FilePath: /unifyxp-v2-store-portal/src/pages/FileLibrary/Components/LayoutSwtich/index.tsx
 */
import React from 'react';
import classname from 'classnames';

import { Icon } from '@/src/tools/icon';

import styles from './style.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

type Props = {
  value: 'grid' | 'list';
  onChange: (value: string) => void;
};

function LayoutSwitch({ value, onChange }: Props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <div className={styles.container}>
      <span className={styles.title}>
        {getI18n('storeFileLibrary.list.layout')}
      </span>

      <Icon
        type='iconlist'
        className={classname(styles.icon, {
          [styles.active]: value === 'list',
        })}
        onClick={onChange.bind(this, 'list')}
      />
      <Icon
        type='icongrid'
        style={{ marginLeft: '14px' }}
        className={classname(styles.icon, {
          [styles.active]: value === 'grid',
        })}
        onClick={onChange.bind(this, 'grid')}
      />
    </div>
  );
}

export default LayoutSwitch;
